import type { AccessTier } from './AccessTier'
import type { AccessGateApi, PromptLoginResult } from './AccessGateApi'
import type { RundotGameAPI } from '../rundot-game-api/types'

export class MockAccessGateApi implements AccessGateApi {
  autoPromptLogin: boolean = true

  constructor(
    private readonly rundotGameApi: RundotGameAPI,
  ) {}

  getAccessTier(): AccessTier {
    const profile = this.rundotGameApi._profileData
    if (!profile || profile.isAnonymous) {
      return 'anonymous'
    }
    return 'authenticated_18plus'
  }

  isAnonymous(): boolean {
    return this.getAccessTier() === 'anonymous'
  }

  async promptLogin(): Promise<PromptLoginResult> {
    const mockConfig = this.rundotGameApi._mock?.accessGate
    if (mockConfig?.simulateLoginSuccess) {
      // Simulate successful login by updating profile
      if (this.rundotGameApi._profileData) {
        this.rundotGameApi._profileData = {
          ...this.rundotGameApi._profileData,
          isAnonymous: false,
        }
      }
      console.warn('[RUN:mock] accessGate.promptLogin() simulated successful login')
      return { success: true, profile: this.rundotGameApi._profileData }
    }

    console.warn(
      '[RUN:mock] accessGate.promptLogin() called — returning false. ' +
      'Set _mock.accessGate.simulateLoginSuccess = true to simulate a successful login.',
    )
    return { success: false }
  }
}
